export const CLIENT_CLIENTS_SIDEBAR_FILTER_INITIAL_VALUES = {
  keywords: null,
}
